import { useState } from 'react'
import type { View } from './derive'
import { reasonText } from './derive'
import { GiveAccess } from './GiveAccess'

/**
 * "Can Maya get into R-147?" — the question people actually ask at 200 robots.
 * The answer names every reason, so a surprising yes says where it came from.
 */
export function CheckAccess({ view }: { view: View }): JSX.Element {
  const [who, setWho] = useState(view.people[0]?.id ?? '')
  const [what, setWhat] = useState(view.machines[0]?.id ?? '')
  const [giving, setGiving] = useState(false)
  const person = view.person(who)
  const machine = view.machine(what)
  const paths = person && machine ? (machine.access.get(person.id) ?? []) : []
  const yes = paths.length > 0

  return (
    <section className="cx-panel cx-panel--padded" aria-label="Can they get in?">
      <h2 className="cx-panel__title">Can they get in?</h2>
      <div className="cx-two">
        <label className="stack" style={{ gap: 4 }}>
          <span className="field-label">Person</span>
          <select value={who} onChange={(e) => setWho(e.currentTarget.value)}>
            {view.people.map((p) => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
        </label>
        <label className="stack" style={{ gap: 4 }}>
          <span className="field-label">Machine</span>
          <select value={what} onChange={(e) => setWhat(e.currentTarget.value)} className="cx-mono">
            {view.machines.map((m) => (
              <option key={m.id} value={m.id}>{m.name}</option>
            ))}
          </select>
        </label>
      </div>
      {person && machine ? (
        <div className={`cx-answer ${yes ? 'is-yes' : ''}`}>
          <strong>{yes ? `${person.name.split(' ')[0]} can SSH into ${machine.name}` : `${person.name.split(' ')[0]} can’t SSH into ${machine.name}`}</strong>
          <span>{yes ? `Through ${paths.map((p) => reasonText(view, p)).join('; and ')}.` : 'No rule reaches it — not their own, and not through a team or a group.'}</span>
        </div>
      ) : (
        <p className="muted">Add people and machines first.</p>
      )}
      {person && machine && !yes ? <button onClick={() => setGiving(true)}>Give {person.name.split(' ')[0]} access to {machine.name}</button> : null}
      {giving && person && machine ? <GiveAccess view={view} preset={{ userId: person.id, machineId: machine.id }} onClose={() => setGiving(false)} /> : null}
    </section>
  )
}
